import { IListOptionsFilter } from "./base";

export interface IValueTemplateFilter extends IListOptionsFilter {
  key: string;
}
